import { IContactOverridePrimaryAddress } from './contact-override-primary-address';
import { ICenterAddress } from './center-address';
import { IListItem } from './list-item';
import { IEmailFlagValue } from './email-flag-value';
import { IPhoneNumber } from './phone-number';
import { ICenter } from './center';
import { IUser } from './user';

export interface IContact {
    id: number,
    organType: number,
    isDeleted: boolean,
    entityType: number,
    entityTypeName: string,
    entityTypeId: number,
    centerName: string,
    positionText: string,
    currentCaseLoad: number,
    maxCaseLoad: number,
    nameHonorific: string,
    fullName: string,
    nameSuffix: string,
    email: string,
    secondaryEmail: string,
    emailSignature?: string,
    addressId1: number,
    address1Suite: string,
    address1Override: IContactOverridePrimaryAddress,
    addressId2: number,
    address2Suite: string,
    address2Override: string,
    galaEmailOverride: string,
    conferenceNumber: string,
    conferenceNumberCode: string,
    conferenceNumberMobileFriendly: string,
    address1: ICenterAddress,
    address2: ICenterAddress,
    positions: IListItem[],
    emailFlags: IEmailFlagValue[],
    phoneNumbers: IPhoneNumber[],
    tags: string[],
    center: ICenter,
    user?: IUser,

    isRccapManager: boolean,
    isLiaison: boolean,
    isSwapManager: boolean,
    isFinancialController: boolean,
    isCfo: boolean,
    isOperations: boolean,
    isMicrositeManager: boolean,
    IsMemberServices: boolean,
    IsDutyOfficer: boolean,
    IsLegalCounsel: boolean,
    IsDirectorOperations: boolean,
    sendEmail?: boolean,

    titles: string[],

    backgroundColor: string,
    color: string,

    firstName: string,
    middleName: string,
    lastName: string,

    abbreviation: string
}
